import React, { useEffect, useState } from "react";
import { SelectAsyncOptionType } from "react-select/async";
import { SmSelectAsyncSearchBox } from "../../../controls/components/selectAsyncSearchBox/SelectAsyncSearchBox";
import { ListDescriptionSearch } from "../../../../services/PartnerService";

export function AdminFilterDesControl(props: {
	filterStaffId?: string;
	doChangeStaffId?: (value: any) => void;
	doChangeOption?: (value: any) => void;
}) {
	const [selectedId, setSelectedId] = useState<string>(props.filterStaffId || "");
	useEffect(() => {
		setSelectedId(props.filterStaffId || "");
	}, [props.filterStaffId]);
	const loadStaffList = async (input: string, setOpts: (val: SelectAsyncOptionType[]) => void) => {
		try {
			const data = await ListDescriptionSearch(input);
			const res = data;
			if (res) {
				const selectOpts = convertToSelectOptions(res);
				const filteredOptions = selectOpts.filter((option: any) =>
					option.label.toLowerCase().includes(input.toLowerCase())
				);
				const clearOption = { label: "All", value: "" };
				setOpts?.([clearOption, ...filteredOptions]);
				return [clearOption, ...filteredOptions];
			}
		} catch (err) {
			console.error(err);
		}

		setOpts([]);
		return;
	};

	return (
		<SmSelectAsyncSearchBox
			selectedId={selectedId}
			onChange={(value: any, item: SelectAsyncOptionType) => {
				setSelectedId(value);
				props.doChangeStaffId?.(value);
				props.doChangeOption?.((item as any)?.object ?? null);
			}}
			loadOptionPromise={loadStaffList}
		/>
	);
}

export function convertToSelectOptions(data: any) {
	let selectOptions = data.map((item: any) => ({
		value: item.id,
		label: item.name,
		object: item,
	}));
	return selectOptions;
}
